import React from 'react';
import ListItemIconBase from '@material-ui/core/ListItemIcon';

const ListItemIcon = ({ children, ...props }) => (
  <ListItemIconBase {...props}>{children}</ListItemIconBase>
);

export default ListItemIcon;
